import AlgoliaData from '@module/Algolia/resources/js/search/interfaces/AlgoliaData';
import ArticleData from '@phoenix/search/interfaces/ArticleData';
import { addQueryIdInUrl, formatUrl, getData, getImage } from '@module/Algolia/resources/js/search/helpers';
import ProductData from '@phoenix/search/interfaces/ProductData';
import StoreData from '@phoenix/search/interfaces/StoreData';

export const transformArticle = (data: AlgoliaData): ArticleData => {
  const title: string = getData(data.title, '');

  return {
    description: getData(data.description, ''),
    id: getData(data.itemId),
    link: formatUrl(getData(data.url, '')),
    rokkaImg: getImage(getData(data.imageCard), title),
    title,
  };
};

export const transformProduct = (data: AlgoliaData): ProductData => {
  const name: string = getData(data.title, '');

  return {
    category: getData(data.category, ''),
    collection: getData(data.collectionName, ''),
    description: [
      getData(data.pp_standardizedSize, ''),
      getData(data.pp_standardizedMainMaterial, ''),
      getData(data.pp_standardizedEnergy, ''),
    ]
      .filter((value) => value !== '')
      .join(', '),
    image: getImage(getData(data.imageCard), name),
    modelReference: getData(data.modelReference, ''),
    name,
    navigationTitle: getData(data.collectionNavigationTitle, ''),
    price: getData(data.price, {}, false),
    sapReference: getData(data.sapReference, ''),
    sellable: getData(data.sellable, false),
    title: getData(data.collectionName, ''),
    url: addQueryIdInUrl(formatUrl(getData(data.url, '')), data._queryID),
  };
};

export const transformStore = (data: AlgoliaData, addressLines: number[] = [1, 2]): StoreData => {
  const title: string = getData(data.title, '');

  return {
    name: title,
    fullAddress: [
      ...addressLines.map((n) => getData(data[`addressLine${n}`], '')),
      getData(data.postalCode, ''),
      getData(data.city, ''),
      getData(data.countryName, ''),
    ]
      .filter((item) => item !== '')
      .join(', '),
    id: getData(data.pageId),
    isOnline: getData(data.isOnline, false),
    isReseller: data.type === 'reseller',
    openingHours: getData(data.openingHours, {}, false),
    permalink: formatUrl(getData(data.url, '')),
    phone: getData(data.phone, ''),
    rokkaImg: getImage(getData(data.imageCard), title),
    seeMoreLabel: getData(data.seeMoreLabel, window.Phoenix.i18n.t('Styleguide.store-locator.see-more')),
    specialDays: [],
    timezone: getData(data.timezone, ''),
    type: getData(data.type, ''),
  };
};
